import { token } from '@atlaskit/tokens';

export const HEADER_BACKGROUND_COLOR = token('elevation.surface');
